export default __webpack_public_path__ + "static/media/SearchSmall.5b7ef959.svg";